"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePersonalBeautyStoreData = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _featureToggles = require("@ori/feature-toggles");
var _fetching = require("@ori/fetching");
var _logger = require("@ori/logger");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("../constants");
var _useCookieStoreInfo = require("../hooks/useCookieStoreInfo");
var _models = require("../models");
var _queriesNet = require("../queries-net");
// istanbul ignore file -- api

const usePersonalBeautyStoreData = enabled => {
  const logger = (0, _logger.useLogger)('usePersonalBeautyStoreData');
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  const {
    headers
  } = (0, _presentationHttp.useHeaders)();
  const {
    type,
    owner
  } = (0, _useCookieStoreInfo.useCookieStoreInfo)();
  const skip = !enabled || !isUserVerified || !isAnonymousUser || type !== _models.ReferralType.PBS || !isFeatureEnabled(_constants.TopAreaFeature.EnableTopAreaBanner) || !owner;
  return (0, _fetching.useGraphqlQuery)({
    url: graphQlNetUrl,
    query: _queriesNet.beautyStoreQuery,
    headers,
    variables: {
      name: owner
    },
    skip,
    onError(error) {
      logger.error(error);
    },
    swrConfig: (0, _presentationUtils.getRetryErrorSwrOptions)()
  });
};
exports.usePersonalBeautyStoreData = usePersonalBeautyStoreData;
